export default __webpack_public_path__ + "assets/icons/apply_user.ef8e825a.svg";